/**
 * The finger of slide 2 ("No celular", NEWS-29): it lands on day 3, drags to
 * the peak of the top campaign, rests, drags to the second campaign and lifts.
 * Pure; the slide runs it 3 times and shows the total while it is lifted.
 */

/** `[day index, time in ms]`, in time order. */
export type FingerKeyframe = readonly [day: number, atMs: number];

export interface FingerPath {
  keyframes: readonly FingerKeyframe[];
  /** After this the finger is lifted (the reading goes back to the total). */
  releaseMs: number;
}

/** Keyframes of the prototype (artifact v5). */
export function estreiaFingerPath(
  peakDay: number,
  secondDay: number
): FingerPath {
  return {
    keyframes: [
      [3, 0],
      [peakDay, 1500],
      [peakDay, 2700],
      [secondDay, 3900],
      [secondDay, 4700],
    ],
    releaseMs: 5600,
  };
}

const easeInOutQuad = (p: number) =>
  p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;

/**
 * Day under the finger at `tMs` of a cycle, or `null` when the finger is not
 * down (before it lands or after `releaseMs`), i.e. the reading shows the total.
 */
export function fingerIndexAt(tMs: number, path: FingerPath): number | null {
  const { keyframes } = path;
  if (tMs < 0 || tMs > path.releaseMs || keyframes.length === 0) return null;
  let k = 0;
  while (k < keyframes.length - 1 && tMs > keyframes[k + 1][1]) k++;
  const [fromDay, fromMs] = keyframes[k];
  const [toDay, toMs] = keyframes[Math.min(k + 1, keyframes.length - 1)];
  const span = Math.max(1, toMs - fromMs);
  const p = Math.min(1, Math.max(0, (tMs - fromMs) / span));
  return Math.round(fromDay + (toDay - fromDay) * easeInOutQuad(p));
}
